import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from "../form/FormMultiSelect";
import TmwApi from "../../containers/Ticket/TmwApi";

class TmwDivisionSelect extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			divisions : [],
		};
	}
	componentDidMount() {
		const { getDivisionList } = this.props;

		getDivisionList({
			callback : (err, r) => {
				if (err) {
					return console.error(err);
				}
				this.setState({ divisions : r.divisions });
			}
		});
	}

	render () {
		const { value } = this.props;
		const { divisions = []} = this.state;

		let options = divisions.map(({division}) => {
			return {
				value: division ,
				display: division ,
			};
		});
		options = _.sortBy(options, 'display');

		return (
			<FormMultiSelect
				{...this.props}
				// so an empty thing doesn't flicker in
				value={_.isEmpty(divisions) ? [] : value}
				options={options}
			/>
		);
	}
}

TmwDivisionSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	getDivisionList : PropTypes.func.isRequired,

	classes : PropTypes.object,
	helpText : PropTypes.string,
};

TmwDivisionSelect.defaultProps =  {
	label : 'Division',
	divisions : [],
};

export default TmwApi(TmwDivisionSelect);
